import { contentTexture } from "../content_textures"
import { Container, Sprite, Texture } from "pixi.js"
import { TileSize } from "game-common/models"

/** Only live additions fade; room snapshots are rendered normally. */
export class LavaTileFade {
    static readonly DURATION_MS = 450
    private cells = new Map<string, { started: number; sprite?: Sprite }>()

    start(key: string, now = Date.now()): void {
        if (!this.cells.has(key)) this.cells.set(key, { started: now })
    }

    cancel(key: string): void {
        const cell = this.cells.get(key)
        cell?.sprite?.destroy()
        this.cells.delete(key)
    }

    // A map rebuild can change the autotile texture, but must keep the fade's original clock.
    clearSprites(): void {
        this.cells.forEach(cell => {
            cell.sprite?.destroy()
            cell.sprite = undefined
        })
    }

    render(key: string, texture: string, x: number, y: number, surface: Container): boolean {
        const cell = this.cells.get(key)
        if (!cell) return false
        cell.sprite?.destroy()
        const sprite = new Sprite(contentTexture(texture))
        sprite.position.set(x * TileSize, y * TileSize)
        sprite.alpha = this.alpha(cell.started, Date.now())
        surface.addChild(sprite)
        cell.sprite = sprite
        return true
    }

    /** Returns true when completed tiles need to be baked into the ground tilemap. */
    update(now = Date.now()): boolean {
        let completed = false
        this.cells.forEach((cell, key) => {
            if (now - cell.started >= LavaTileFade.DURATION_MS) {
                this.cancel(key)
                completed = true
            } else if (cell.sprite) {
                cell.sprite.alpha = this.alpha(cell.started, now)
            }
        })
        return completed
    }

    clear(): void {
        this.clearSprites()
        this.cells.clear()
    }

    private alpha(started: number, now: number): number {
        const t = Math.max(0, Math.min(1, (now - started) / LavaTileFade.DURATION_MS))
        return t * t * (3 - 2 * t)
    }
}
